import { Folder } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const MoveToFolderDialog = ({
  open,
  onOpenChange,
  workspaceName,
  folders,
  selectedFolderId,
  setSelectedFolderId,
  onMove,
  loading
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md dark:bg-slate-800 dark:border-slate-700">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 dark:text-gray-100">
            <Folder className="w-5 h-5 text-[#4A9CC7]" />
            Move "{workspaceName}" to Folder
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label className="dark:text-gray-300">Select Folder</Label>
            <Select value={selectedFolderId || 'none'} onValueChange={setSelectedFolderId}>
              <SelectTrigger data-testid="folder-select" className="dark:bg-slate-900 dark:border-slate-600">
                <SelectValue placeholder="Select a folder" />
              </SelectTrigger>
              <SelectContent className="dark:bg-slate-800 dark:border-slate-700">
                <SelectItem value="none">
                  <div className="flex items-center gap-2">
                    <Folder className="w-4 h-4 text-muted-foreground" />
                    <span>No Folder (Root)</span>
                  </div>
                </SelectItem>
                {folders && folders.map(folder => (
                  <SelectItem key={folder.folder_id} value={folder.folder_id}>
                    <div className="flex items-center gap-2">
                      <Folder className="w-4 h-4" style={{ color: folder.color || '#6B7280' }} />
                      <span>{folder.name}</span>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          {folders && folders.length === 0 && (
            <p className="text-sm text-muted-foreground">
              No folders yet. Create a folder first using the folder icon in the sidebar.
            </p>
          )}
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" className="dark:border-slate-600 dark:text-gray-300">Cancel</Button>
          </DialogClose>
          <Button 
            onClick={onMove}
            disabled={loading}
            className="bg-[#4A9CC7] hover:bg-[#3d8ab5]"
            data-testid="move-to-folder-btn"
          >
            {loading ? 'Moving...' : 'Move'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MoveToFolderDialog;
